export default __webpack_public_path__ + "static/media/AICTE.1f267229.png";